<template>
	<div style="background-color: #000;color:#fff;height: 100vh;">
	    <div style="text-align: center;padding: 60px;font-size: 54px;font-weight: 900;">
	        {{ $t('message.fittingLogin') }}
	    </div>
	    <div style="text-align: center;">
	        <span v-if="src==''" style="width: 200px;height: 200px;border:1px solid #fff;">
	            {{ $t('message.loading') }}
	        </span>
	        <img v-else :src="src" style="width: 200px;height: 200px;;" />
	        <br>
	        <br>
	        <br>
	        <span style="margin-top: 20px;font-weight: 900;">
	            {{ $t('message.scanToLogin') }}
	        </span>         
	    </div>
	    <div style="position: absolute;right: 20px;top: 20px;">
	        {{ $t('message.switchLanguage') }}:
	        <button style="padding: 3px;background-color: #000;color: #fff;border-radius: 2px;border: 1px solid #fff;margin-left: 10px;" 
	            @click="switchLanguage">
	            {{ $t('message.language') }}
	        </button>
	    </div>
		<div style="text-align: center;margin-top: 50px;">		
			<img  src="https://bike.typhcl.cn/md/imgs/con.jpg" style="height:300px;width: 600px;" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login', // 组件的名称，根据实际情况替换 'YourComponentName'
		data() {
			return {
				// 在这里定义你的组件数据
				src: "",
				token: "",
			};
		},
		computed: {
			// 计算属性
		},
		methods: {
			switchLanguage() {
				const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
				this.$i18n.locale = newLang;
				localStorage.setItem('lang', newLang); // 记住用户选择的语言
			},
			// 方法
			ref_code() {
				var that = this
				$.ajax({
					url: that.URL,
					data: {
						t: "login_init",
					},
					dataType: "json",
					success(e) {
						console.log(e)
						that.$data.src = e.url
						that.$data.token = e.token;
						console.log(that.$data.src)
					}
				})
			},
			check_login() {
				var that = this

				$.ajax({
					url: that.URL,
					data: {
						t: "check_login",
						token: that.token,
					},
					dataType: "json",
					success(e) {
						if (e.sta == 1) {
							localStorage.setItem('token', that.token);
							that.$router.replace('/');
						} else {
							setTimeout(function() {
								that.check_login();
							}, 3000)
						}
					}
				})
			},

		},
		mounted() {
			var that = this
			// 组件挂载后执行的代码
			that.ref_code();
			that.check_login()
		}
	}
</script>

<style>
</style>